import axios from "./axiosInstance";

const categoryAPI = {
  getDetails: (params) => axios.get("categories/tree", {params}),

  addDetails: (payload) => axios.post("categories/", payload),

  updateDetails: (id, payload) => axios.put(`categories/${id}`, payload),

  getSingleDetails: (id) => axios.get(`categories/${id}/subtree`),
  
  getCategoryDetails: (id) => axios.get(`categories/${id}`),

  updateStatus: (id, payload) =>
    axios.patch(`categories/${id}/visibility`, payload),

  updateActiveStatus: (id) => axios.patch(`categories/${id}/status`),

  updateOrder: (payload) => axios.put("categories/reorder", payload),

  deleteItem: (id) => axios.delete(`categories/${id}`),
  
  getListforDropdown: () => axios.get("categories/dropdown"),
};

export default categoryAPI;
